export enum PosthogFeatureFlag {
  TASKS_SYSTEM = 'tasks_system',
  BTL_CASE_SIDEBAR = 'btl_case_sidebar',
}
